module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-windowdoor.png?447384d6765742c40049d5a7d4e05e34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-windowdoor.png
// module id = 1057
// module chunks = 1